

















import {User} from 'firebase';
import {Component, Emit, Prop, Vue, Watch} from 'vue-property-decorator';
import BButton from 'buefy/src/components/button/Button.vue';
import {Action, Getter, State} from 'vuex-class';
import BUpload from 'buefy/src/components/upload/Upload.vue'; // @ is an alias to /src
import BField from 'buefy/src/components/field/Field.vue'; // @ is an alias to /src
import BDropdown from 'buefy/src/components/dropdown/Dropdown.vue';
import BDropdownItem from 'buefy/src/components/dropdown/DropdownItem.vue';
import BSelect from 'buefy/src/components/select/Select.vue';
import BRadio from 'buefy/src/components/radio/Radio.vue';
import {MAFUser} from '@/store/User/types';
import * as _ from 'lodash';
import {RadioAvatarOption} from './types';

const namespace = 'userState';

@Component({
    components: {

    },
})
export default class RadioButton extends Vue {
    @Prop() public value!: RadioAvatarOption;
    @Prop() public nativeValue!: RadioAvatarOption;
    @Prop() public currentOption!: any;
    @Prop(MAFUser) public readonly myself!: MAFUser;

    public newValue!: RadioAvatarOption;
    public BASE_URL: string = process.env.BASE_URL ? process.env.BASE_URL : '';
    constructor() {
        super();
    }
    get pic() {
        if (this.value.option === this.nativeValue.option) {
            return this.nativeValue.active_btn;
        }
        return this.nativeValue.inactive_btn;
    }

    get computedValue() {
        return this.newValue;
    }
    set computedValue(value) {
        this.newValue = value;
        this.$emit('input', value);
    }

    public selectButton() {
        if (!this.nativeValue.disabled) {
            this.computedValue = this.nativeValue;
        } else {
            // TODO: purchase item
        }
    }

    @Watch('value', {deep: true})
    public setValue(value: any) {
        this.newValue = value;
    }
}
